import { Meta, QueryParams } from "@/models/general";
import User from "@/models/user";
import api from "@/plugins/axios";

const UsersAPI = {
  async getUsers(params: QueryParams): Promise<{ data: User[]; meta: Meta }> {
    return api.get("/users", {
      params: params,
    });
  },
  async getUser(id: string): Promise<User> {
    return api.get(`/users/${id}`);
  },
  async getCurrentUser(): Promise<User> {
    return api.get("/users/current_user");
  },
  async updateUser(user: User): Promise<User | undefined> {
    return api.put(`/users/${user.id}`, user);
  },
  async deleteUser(id: string): Promise<void> {
    return api.delete(`/users/${id}`);
  },
  async updateRole(user: User): Promise<void> {
    return api.put(`/users/${user.id}/role`, user);
  },
};

export default UsersAPI;
